import { FleekError } from './FleekError';

type GitAccessTokenInvalidErrorOptions = {
  projectId?: string;
};

export class GitAccessTokenInvalidError extends FleekError<GitAccessTokenInvalidErrorOptions> {
  public name = 'GitAccessTokenInvalidError';

  toString = () => {
    return 'The git access token for the user is invalid';
  };
}
